const imgLoader = ({ src, width, quality }) => {
  return `${process.env.NEXT_PUBLIC_BASE_URL}/Site/GetFileByte?${src}`;
};

export default imgLoader;
